module.exports = __webpack_public_path__ + "static/Commune-Nuit_Debout_web-b239376a3718aabade70a0adb55461ce.ttf";